import { render, staticRenderFns } from "./NewMajorEvents.vue?vue&type=template&id=0e4b70e9&scoped=true&"
import script from "./NewMajorEvents.vue?vue&type=script&lang=js&"
export * from "./NewMajorEvents.vue?vue&type=script&lang=js&"
import style0 from "./NewMajorEvents.vue?vue&type=style&index=0&id=0e4b70e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b70e9",
  null
  
)

export default component.exports